import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { HeaderSizes, ThemeVariants } from '../constants'
import { borderRadiusRule } from '../constants/cssRules'
import { DEFAULT_CONFIG } from '../constants/styledComponents'
import Block from './Block'
import Header from './Header'

const StyledProgressBar = styled.div.withConfig(DEFAULT_CONFIG)`
    ${props => `
    background: linear-gradient(90deg, ${props.themeContext.main}, ${
        props.themeContext.secondary
    });
    ${borderRadiusRule(props)}
`}
`

const ProgressBar = ({
    progress,
    showPercentage,
    text = "Please wait, we're working on it...",
}) => {
    const themeContext = useContext(ThemeContext)
    return (
        <div style={{ display: 'inline-block', minWidth: '250px' }}>
            <div className='rds-flex rds-align-center rds-direction-column'>
                {showPercentage ? (
                    <Header
                        title={`${progress}%`}
                        text={text}
                        size={HeaderSizes.MEDIUM}
                        alignCenter
                    />
                ) : null}
                <Block
                    roundedBorder
                    variant={ThemeVariants.GRAY}
                    className='progress-bar_wrapper rds-full-block rds-m_top__sm'
                >
                    <StyledProgressBar
                        themeContext={themeContext}
                        className='progress-bar'
                        style={{ width: `${progress}%` }}
                    />
                </Block>
            </div>
        </div>
    )
}

export default ProgressBar
